"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgAntennaOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.antenna_outline_svg__cls-1{display:none}')),
        React.createElement("g", { id: "antenna_outline_svg__transparent_box" },
            React.createElement("path", { className: "antenna_outline_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "antenna_outline_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("g", { id: "antenna_outline_svg__OUTLINE" },
            React.createElement("path", { d: "M14.99 11h2v19h-2zM25.19 2.29l-1.42 1.42a11 11 0 010 15.58l1.42 1.42a13.06 13.06 0 000-18.42zM8.22 3.71L6.8 2.29a13 13 0 000 18.42l1.42-1.42a11 11 0 010-15.58z" }),
            React.createElement("path", { d: "M10.34 5.84a8 8 0 000 11.32l1.41-1.41a6 6 0 010-8.5zM21.65 5.84l-1.41 1.41a6 6 0 010 8.5l1.41 1.41a8 8 0 000-11.32z" }))));
}
exports.default = SvgAntennaOutline;
//# sourceMappingURL=AntennaOutline.js.map